import { FC, MouseEventHandler } from "react";

export interface IButtonProps {
    children: React.ReactNode;
    onClick: MouseEventHandler<HTMLButtonElement>;
    label: string;
}
const Button : FC<IButtonProps> = ({ children, onClick, label }) => {
    return (
        <button
            onClick={onClick}
            type="button"
            className="page-link font-body1"
            aria-label={label}
        >
            {children}
        </button>
    )
}

export default Button;
